export { default } from "./QueryMap.gql";
